import React from 'react';
import fetch from '../../core/fetch';
import { wk_app_public } from '../../config';

class LoginWK extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      sAMLRequest: null,
      relayState: null
    }

    this.goToLogin.bind(this);
  }

  /**
   * Przed zamontowaniem komponentu, wysylany jest request do plikacji
   * odpowiedzialnej za komunikacje z WK, po wartosc parametru SAMLRequest
   * oraz wysylane jest zapytanie do node serwera o dodanie nowego RelayState
   * zawierajacego url tego zadania. RelayState jest zwracane pozniej przez
   * WK w HttpRedirectBinding, w naszym przypadku przekierowanie wykonywane jest
   * do /wk/:prefix_gminy, gdzie tworzona jest nowa sesja a nastepnie user jest
   * przekierowywany dalej do adresu zawartego w RelayState.
   */
  componentDidMount() {
    const promiseToGetSAMLRequest = this.getSAMLRequest();
    const promiseToGetRelayState = this.postRelayState();

    Promise.all([promiseToGetSAMLRequest, promiseToGetRelayState]).then((values) => {
      this.setState({
        sAMLRequest: values[0].authnRequest,
        relayState: values[1].token,
      }, () => {
          // Na tym etapie, state juz powinien byc ustawiony
          // mozna wykonac submit formularza
          this.goToLogin();
      })
    });
  }

  /**
   * Do url mozna dodac parametr loa - level of assurance okreslajacy poziom
   * bezpieczenstwa na podstawie EiDAS, dostapne wartosci to:
   * low, substantial (domyslna wartosc), high
   */
  getSAMLRequest = () => fetch(`${wk_app_public }/authn/${this.props.prefix}?loa=substantial`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json'
    },
  })
    .then((resp) => {
      if (resp.status === 200) {
        return resp.json();
      } else {
        // TODO: obsluga blednego requestu, chyba po prostu przekierowanie do glownej
        window.location.pathname = '/';
      }
    })
    .catch(error => {
      console.error(error);
      window.location.pathname = '/';
    })

  postRelayState = () => fetch('/relay/add', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ url: window.location.pathname + window.location.search }),
  })
    .then(resp => {
      if (resp.status === 201) {
        return resp.json();
      } else {
        // TODO: obsluga blednego requestu, chyba po prostu przekierowanie do glownej
        window.location.pathname = '/';
      }
    })

  goToLogin() {
    this.submitBtn.click();
  }

  render() {

    return this.state.relayState && this.state.sAMLRequest ? (
      <div>
        <form method="post" action="https://login.gov.pl/login/SingleSignOnService">
          <input type="hidden" name="SAMLRequest" value={this.state.sAMLRequest} />
          <input type="hidden" name="RelayState" value={this.state.relayState} />
          <input
            ref={(input) => { this.submitBtn = input; }}
            type="submit"
            value="Go to login"
            style={{
              visibility: 'hidden'
            }}
          />
        </form>
      </div>
    ) : <div />;
  }
}


export default LoginWK;



// WEBPACK FOOTER //
// src/routes/eservices/loginWK.js